module.exports = __webpack_public_path__ + "img/list1.5f89ba41.png";